const IfuPage = () => {
    return (
        <div
            style={{
                width: '100%',
                height: 'calc(100vh - 120px)',
                padding: '16px'
            }}
        >
            <iframe
                src="./assets/static/Instructions_for_use.pdf"
                title="Instructions for use"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
            />
        </div>
    )
}

export default IfuPage